import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useComponentSize, useDragScroll, useIsMobileDimension, useManyRefs, useResizeObserved } from '@carnica/utils/hooks';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useScrollDeviceDetect } from "../../../../hooks/useScrollDeviceDetect";
import { calculateOffset, calculateWrapperHeight, getNodeSize } from "./utils";
var getSize = function getSize(val) {
  return typeof val === 'string' ? val : "".concat(val, "px");
};
export var useWrapperAnimation = function useWrapperAnimation(_ref) {
  var layout = _ref.layout,
    isRow = _ref.isRow,
    _ref$itemsCount = _ref.itemsCount,
    itemsCount = _ref$itemsCount === void 0 ? 0 : _ref$itemsCount;
  var wrapperRef = useRef(null);
  var wrapperWidth = useComponentSize(wrapperRef, [layout]).width;
  var isMobile = useIsMobileDimension();
  var itemRefs = useManyRefs(itemsCount);
  var sizes = useResizeObserved(itemRefs, getNodeSize, [layout]);
  var scrollDevice = useScrollDeviceDetect();
  var _useState = useState('auto'),
    _useState2 = _slicedToArray(_useState, 2),
    itemHeight = _useState2[0],
    setItemHeight = _useState2[1];

  // Выключаем скролл по нажатию для устройств без мыши, так как там в этом нет необходимости (на мобилках и так работает, а на тачпаде есть горизонтальный скролл)
  useDragScroll(wrapperRef, 'horizontal', scrollDevice === 'mouse' && (layout === 'line' || layout === 'collapse' && isRow));
  var height = useMemo(function () {
    if (layout === 'collapse' && itemHeight !== 'auto') {
      return calculateWrapperHeight(sizes, itemHeight, wrapperWidth, calculateOffset(wrapperRef), isMobile);
    }
    return 'auto';
  }, [itemHeight, wrapperWidth, layout, isMobile]);
  useEffect(function () {
    if (wrapperRef.current && isRow) {
      wrapperRef.current.dataset.isCollapsed = String(isRow);
      setItemHeight('auto');
    }
  }, [isRow]);
  useEffect(function () {
    setItemHeight(Math.max.apply(Math, _toConsumableArray(sizes.map(function (size) {
      return size.height;
    }))) || 'auto');
  }, [sizes]);
  useEffect(function () {
    var wrapper = wrapperRef.current;
    if (wrapper) {
      wrapper.style.setProperty('--chips-group-height', itemHeight === 'auto' ? 'auto' : getSize(isRow ? itemHeight + 8 : height));
      wrapper.style.setProperty('--chips-group-item-height', itemHeight === 'auto' ? 'auto' : "".concat(itemHeight, "px"));
    }
  }, [isRow, height, layout, itemHeight]);
  return useMemo(function () {
    return {
      wrapperRef: wrapperRef,
      itemRefs: itemRefs
    };
  }, []);
};